export const detectMobile = (): boolean => {
  let check = false;
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
      navigator.userAgent || navigator.vendor
    )
  ) {
    check = true;
  }
  return check;
};

export const isIOSDevice = (): boolean => {
  const platform: string = navigator?.platform || "unknown";
  return (
    (/iPad|iPhone|iPod/i.test(platform) ||
      (platform === "MacIntel" && navigator.maxTouchPoints > 1)) &&
    !("MSStream" in window)
  );
};

export const getDeviceType = (): string => {
  const userAgent = navigator.userAgent;

  // Facebook/Instagram in-app browser
  if (/(FBAN|FBAV|Instagram)/i.test(userAgent)) {
    return "InAppBrowser";
  }

  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) {
    return "Tablet";
  }

  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      userAgent
    )
  ) {
    return "Mobile";
  }

  if (window.innerWidth <= 800 && window.innerHeight <= 600) {
    return "Mobile";
  }

  return "Desktop";
};
